import{erpplatfileserver} from '@/utils/baseUrl';
import{reportserver,file_url} from '@/utils/baseUrl';
import {post} from '@/utils/request';

//报表
export async function loadReportData(params) {
    return post(reportserver+"/report/getReportData", params, true);
};
//报表view
export async function loadReportView(params) {
    return post(reportserver+"/report/getReportView", params, true);
};
//报表
export async function loadReportTemplate(params) {
    return post(reportserver+"/report/getReportTemplate", params, true);
};

//报表save
export async function saveReportTemplate(params) {
    return post(reportserver+"/report/saveReportTemplate", params, true);
};
//报表delete
export async function deleteReportTemplate(params) {
    return post(reportserver+"/report/deleteReportTemplate", params, true);
};
//报表
export async function loadReportList(params) {
    return post(reportserver+"/report/getReportList", params, true);
};
//报表
export async function loadReportAllList(params) {
    return post(reportserver+"/report/getReportDesignList", params, true);
};

//报表
export async function download(params) {
    return post(erpplatfileserver+'/reportForm/download', params, true);
};

//ImportDatasave
export async function saveImportData(params) {
    return post(reportserver+"/importdata/saveImportData", params, true);
};
export async function deleteImportData(params) {
    return post(reportserver+"/importdata/deleteImportData", params, true);
};
export async function deleteImportDetail(params) {
    return post(reportserver+"/importdata/deleteImportDetail", params, true);
};
export async function updateImportDetail(params) {
    return post(reportserver+"/importdata/updateImportDetail", params, true);
};
export async function loadImportList(params) {
    return post(reportserver+"/importdata/getImportList", params, true);
};
export default {
    loadReportData,
    loadReportView,
    loadReportList,
    download,
    loadReportTemplate,
    saveReportTemplate,
    deleteReportTemplate,
    loadReportAllList,
    loadImportList,

};





